import merge from 'deepmerge';

import { getLanguages } from '../../utilities';

export default function renderLanguages(controls, baseUrl, defaultLang) {
  const languagesList = getLanguages(baseUrl);
  const filteredItemsLanguages = controls.map(item => {
    const fullItem = languagesList.find(language => language.name === item.name);
    const newItem = merge(item, fullItem);
    item = {};
    item = { ...newItem };
    item.default = defaultLang ? item.name === defaultLang : item.position === 1;
    return item;
  });
  filteredItemsLanguages.unshift(
    filteredItemsLanguages.splice(
      filteredItemsLanguages.findIndex(item => item.default === true),
      1
    )[0]
  );
  return filteredItemsLanguages;
}
